import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EGiftPromoCode } from "src/app/shared/models/eGift/EGiftPromoCode.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import * as uuid from "uuid";

@Component({
	selector: "app-e-gift-promo-code-setup",
	templateUrl: "./e-gift-promo-code-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EGiftPromoCodeSetupComponent implements OnInit {
	@Input() eGiftVenue: EGiftVenue;

	eGiftPromoCodes: EGiftPromoCode[];
	eGiftPromoCodeSelected: EGiftPromoCode;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		await this.getPromoCodes(this.venueSvc.venueKey);
	}

	attachMenuItemsToPromoCodes() {
		this.eGiftPromoCodes.forEach((i) => {
			if (i.menuItemKey) {
				i.menuItemName = this.venueSvc.ooMenuItems.find((n) => n.menuItemKey === i.menuItemKey).name;
			}
		});
	}

	async getPromoCodes(venueKey) {
		const resp = await this.focuslink.eGiftPromoCodeGetAll(venueKey);
		this.eGiftPromoCodes = resp.map((i) => {
			return new EGiftPromoCode(i);
		});
		this.attachMenuItemsToPromoCodes();
	}

	async newPromoCode() {
		this.eGiftPromoCodeSelected = new EGiftPromoCode({
			guid: uuid.v4(),
			venueKey: this.venueSvc.venueKey,
			active: true,
		});
	}

	async savePromoCode(rec) {
		const resp = await this.focuslink.eGiftPromoCodePost(this.venueSvc.venueKey, rec);
		const promo = new EGiftPromoCode(resp);

		let codeIdx = this.eGiftPromoCodes.findIndex((i) => i.promoCode === resp.promoCode);
		if (codeIdx === -1) {
			this.eGiftPromoCodes.push(promo);
		} else {
			this.eGiftPromoCodes[codeIdx] = promo;
		}
		this.attachMenuItemsToPromoCodes();
		this.eGiftPromoCodeSelected = undefined;
	}
}
